import React, { useEffect } from 'react';
import { useGetParticipantsListQuery } from '../../services/RttBridgeApi';

import DeleteParticipant from './DeleteParticipant';
import './ParticipantList.css';

interface ParticipantListProps {
    conferenceId: string | undefined;
    setCount: (count: number) => void;
}

const ParticipantList: React.FC<ParticipantListProps> = ({ conferenceId, setCount }) => {

    const { data: partList } = useGetParticipantsListQuery({ id: conferenceId });

    let participants: [] = [];
    let count: number = 0;
    if (partList !== undefined) {
        participants = partList.participants;
        count = partList.count;
    }

    // Use useEffect to update the count in the parent component after rendering
    useEffect(() => {
        setCount(count);
    }, [count, setCount]);

    return (

        <ul>
            < h4 className={'part-header'} >Members list</h4 >
            {participants.length >= 1 ?
                participants.map((participant: any) => (
                    <div key={participant.id}>
                        <li className={'part-list'}>
                            <p className='conf-name'><strong>{participant.name}</strong></p>
                            <DeleteParticipant conferenceId={conferenceId} participantId={participant.id} />
                        </li>
                        <small><p className='conf-name'>{participant.id}</p></small>
                    </div>
                ))

                :
                <p>List is empty</p>}
        </ul >

    );
};

export default ParticipantList;